import { ProgressBar } from 'gatorcomponents';
import React, { useCallback, useEffect, useState } from 'react';
import * as Styles from './ProgressBarBlock.styles';
import { useFeatureValue } from '@growthbook/growthbook-react';
import { CHARLIE_CLOUDFLARE_TIMERS } from '@/config/GrowthBook/constants';

const ProgressBarBlock = ({
  texts,
}) => {
  const { betweenProgressBarIteration } = useFeatureValue(CHARLIE_CLOUDFLARE_TIMERS) || { betweenProgressBarIteration: 5000 };
  const [progress, setProgress] = useState(0);
  const [textStep, setTextStep] = useState(0);

  const updateProgress = useCallback(() => {
    if (progress < 99) {
      const timeoutId = setTimeout(() => {
        if ((texts.length - 1) > textStep) {
          setTextStep(textStep + 1);
        }
        setProgress(progress + 50);
      }, betweenProgressBarIteration);
      return () => clearTimeout(timeoutId);
    }
  }, [progress, textStep, texts, betweenProgressBarIteration]);

  useEffect(() => {
    const cleanup = updateProgress();
    return cleanup;
  }, [updateProgress]);

  useEffect(() => {
    setProgress(10);
  }, []);

  return (
    <Styles.Wrapper data-testid="loader">
      <Styles.Title data-testid="loaderText">
        {texts[textStep]}
      </Styles.Title>

      <Styles.ProgressBarWrapper>
        <ProgressBar progress={progress} />
      </Styles.ProgressBarWrapper>
    </Styles.Wrapper>
  );
};

export default ProgressBarBlock;
